/**
 * 灵感词相关类型定义
 *
 * @module types/inspirationWords
 */

/**
 * 操作类型枚举
 */
export enum OperationType {
  CLICK = "click",
  RIGHT_CLICK = "right_click",
  COLLECT = "collect",
  DOWNLOAD = "download",
}

/**
 * 推荐词元数据（包含埋点所需的分发标识）
 */
export interface WordMetadata {
  /** 推荐词文本 */
  word: string;
  /** 分发标识（从 API ext.dist_code 获取） */
  distCode: string;
}

/**
 * 操作记录
 */
export interface OperationRecord {
  /** 内容ID（文件ID） */
  fileId: string;
  /** 操作类型 */
  type: OperationType;
  /** 操作时间戳 */
  timestamp: number;
  /** 推荐词元数据列表 */
  recommendWords?: WordMetadata[];
}

/**
 * 触发配置
 */
export interface TriggerConfig {
  /** 2分钟内需要操作的内容数量 */
  twoMinutesCount: number;
  /** 3分钟内需要操作的内容数量 */
  threeMinutesCount: number;
  /** 冷却时间（分钟） */
  cooldownMinutes: number;
}

/**
 * 触发类型
 */
export type TriggerType = "共现触发" | "累计触发";

/**
 * 触发结果
 */
export interface TriggerResult {
  /** 是否触发 */
  triggered: boolean;
  /** 触发的内容ID（文件ID） */
  fileId?: string;
  /** 推荐词元数据列表 */
  words?: WordMetadata[];
  /** 触发类型（共现触发 / 累计触发） */
  triggerType?: TriggerType;
  /** 来源的 file_ids 列表（逗号分隔，用于埋点） */
  sourceFileIds?: string;
}

/**
 * 展示的推荐词模块数据（用于渲染和埋点）
 */
export interface DisplayedModule {
  /** 推荐词元数据列表 */
  words: WordMetadata[];
  /** 触发类型 */
  triggerType: TriggerType;
  /** 来源的 file_ids 列表（逗号分隔） */
  sourceFileIds: string;
}
